export const useEntryStore = defineStore('entryStore', {
    state: () => ({
        entry: {},

        seomatic: {},
        variables: {},
    }),
    actions: {
        async loadEntry(uri) {
            const { cmsQuery } = useGraphQL()

            const {data: pageData } = await cmsQuery({
                uri: `page-data/page/${uri}`,
                key: `entry-${uri}`,
            })

            const redirect = get(pageData.value?.data, 'retourResolveRedirect', {})

            if (redirect && !isEmpty(redirect.redirectDestUrl) && redirect.enabled) {
                const route = useRoute()
                return navigateTo({
                    path: redirect.redirectDestUrl,
                    query: route.query
                }, {
                    redirectCode: redirect.redirectHttpCode || 301,
                    replace: true,
                    external: true
                })
            }

            // replace page data entry
            this.entry = get(pageData.value?.data, 'entry', {})

            if (isEmpty(this.entry?.slug)) {
                throw createError({
                    statusMessage: 'Page not found',
                    message: 'The page you are looking for does not exist. <br /><br />Try finding what you are looking for by searching from the top menu or return back to the homepage',
                    statusCode: 404,
                })
            }

            // Handle RedirectPage entries
            if (this.entry?.__typename === 'ds_RedirectPage_Entry') {
                const redirectUrl = this.entry?.redirectLink?.[0].linkUrl

                if (redirectUrl) {
                    return navigateTo({
                        path: redirectUrl,
                        query: useRoute().query
                    }, {
                        redirectCode: 301,
                        replace: true,
                        external: true
                    })
                }
            }

            this.initEntry()
        },

        async loadArticle(type: string, slug: string) {
            const { cmsQuery } = useGraphQL()

            const {data: articleData } = await cmsQuery({
                uri: `page-data/article/${type}/${slug}`,
                key: `entry-${type}-${slug}`,
            })


            // replace page data entry
            this.entry = get(articleData.value?.data, 'entry', {})

            if (isEmpty(this.entry?.slug)) {
                throw createError({
                    statusMessage: 'Page not found',
                    message: 'The page you are looking for does not exist. <br /><br />Try finding what you are looking for by searching from the top menu or return back to the homepage',
                    statusCode: 404,
                })
            }

            this.initEntry()

        },

        initEntry() {
            const micrositeStore = useMicrositeStore()

            this.seomatic = get(this.entry, 'seomatic', {})
            this.variables = JSON.parse(get(this.seomatic, 'metaSiteVarsContainer', '{}'))

            // check if microsite
            if(['ds_MicrositeHomepage_Entry', 'ds_MicrositePage_Entry'].includes(this.entry.__typename)) {
                micrositeStore.initMicrosite(this.entry)
            }
        },


    },
})
